import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LibraryService {

  constructor() { }

  formatData(data) {
    if (!data || data.length === 0) return;

    // 按照 order 字段升序排序
    const sortedData = [...data].sort((a, b) => a.order - b.order);

    // 重新赋值递增的 order，从 1 开始，并处理 maxSize
    sortedData.forEach((item, index) => {
      item.order = index + 1;

      // 处理 maxSize：向上取整，负数设为 0
      const rawSize = Number(item.maxSize);
      item.maxSize = isNaN(rawSize) ? 0 : Math.max(0, Math.ceil(rawSize));
    });

    console.log('Preview sorted data:', sortedData);
    return sortedData;
  }


}
